<!-- Items Detail Page will display here -->

<div class="container-fluid">
        <div class="row">
            <div class="col-lg-8 col-xl-9 col-md-12 col-xs-12 col-sm-12 col-12">    
                <div class="card" id="zsd-itemdetail" style="margin-top: 5rem;">
                    <div class="card-body">
                            <zsd-itemdetail></zsd-itemdetail>
                    </div>
                </div>
            </div>    
            <div class="col-lg-4 col-xl-3 d-none d-lg-block d-xl-block">    
                    <div class="card" id="zsd-itemrelatedrequests" style="margin-top: 5rem;">
                        <div class="card-body"  id="item_related_requests_card">
                             <zsd-itemrelatedrequests></zsd-itemrelatedrequests>
                        </div>
                    </div>
                </div>    
        </div>
    </div>